export default __webpack_public_path__ + "static/media/cusco-vinicunca_autoportrait.3e274ebe.jpg";